import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { translate } from '../../../../base/i18n/functions';
import { getDeviceStatusText, getDeviceStatusType } from '../../../functions';
import { IconWarningCircle } from "../../../../base/icons/svg";
import Icon from "../../../../base/icons/components/Icon";
const useStyles = makeStyles()(theme => {
    return {
        deviceStatus: {
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'start',
            gap: '8px',
            color: 'rgba(255, 255, 255, 0.7)',
            width: 'calc(100% - 58px)',
            position: 'absolute',
            bottom: '268px',
            zIndex: 1,
            fontWeight: 'normal',
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '-0.16px',
            '&.device-status-error-mobile': {
                background: 'linear-gradient(122.89deg, rgba(28, 28, 28, 0.8) -31.07%, rgba(28, 28, 28, 0.8) 6.08%, rgba(28, 28, 28, 0.8) 42.1%, rgba(28, 28, 28, 0.8) 89.18%, rgba(28, 28, 28, 0.8) 122.33%)',
                border: '1px solid rgba(255, 255, 255, 0.05)',
                borderRadius: '8px',
                padding: '12px',
                textAlign: 'start'
            },
        },
        warningCircle: {
            opacity: '0.65',
        },
        title: {
            fontFamily: 'Lato Bold',
            color: 'rgba(255, 255, 255, 0.8)',
        },
        desc: {
            fontFamily: 'Lato SemiBold',
            color: 'rgba(255, 255, 255, 0.7)',
        },
    };
});
/**
 * Strip showing the current status of the devices.
 * User is informed if there are missing or malfunctioning devices.
 *
 * @returns {ReactElement}
 */
function DeviceStatusMobile({ deviceStatusType, deviceStatusText, t }) {
    const { classes, cx } = useStyles();
    const hasError = deviceStatusType === 'warning';
    const containerClassName = cx(classes.deviceStatus, { 'device-status-error-mobile': hasError });
    if (!hasError) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { style: { padding: '0 16px' } },
        React.createElement("div", { className: containerClassName, role: 'alert', tabIndex: -1 },
            React.createElement(Icon, { "aria-hidden": true, className: classes.warningCircle, color: 'rgba(255, 255, 255, 0.3)', size: 60, src: IconWarningCircle }),
            React.createElement("div", null,
                React.createElement("div", { className: classes.title }, t('prejoin.errorNoPermissionsTitle')),
                React.createElement("div", { className: classes.desc }, t('prejoin.errorNoPermissions'))))));
}
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @returns {{ deviceStatusText: string, deviceStatusText: string }}
 */
function mapStateToProps(state) {
    return {
        deviceStatusText: getDeviceStatusText(state),
        deviceStatusType: getDeviceStatusType(state)
    };
}
export default translate(connect(mapStateToProps)(DeviceStatusMobile));
